import { ChainId } from '@traderjoe-xyz/joepegs-sdk'

export const DATA_API_URL = 'https://data-api.avax.network/v1'

export const getRoutescanApiUrl = (chainId: ChainId): string => {
  switch (chainId) {
    case ChainId.AVALANCHE:
      return 'https://api.routescan.io/v2/network/mainnet/evm/43114/etherscan/api'
    case ChainId.FUJI:
      return 'https://api.routescan.io/v2/network/testnet/evm/43113/etherscan/api'
    default:
      throw new Error(`Routescan is not configured for chain ${chainId}`)
  }
}
